import { GET_TEMPLATES_LIST_SUCCESS } from "../templates/actions";
import {
  GET_TEMPLATES_LIST_FAILURE,
  GET_TEMPLATES_LIST_REQUEST
} from "./actions";

const initialState = {
  templates: {},
  isChanged: false
};

export default function filesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEMPLATES_LIST_SUCCESS: {
      return { ...state, templates: action.payload, isChanged: false };
    }
    case GET_TEMPLATES_LIST_REQUEST: {
      return { ...state, isChanged: true };
    }
    case GET_TEMPLATES_LIST_FAILURE: {
      return { ...state, isChanged: false };
    }

    default:
      return { ...state };
  }
}
